import instance from '../utils/axios';

export const fetchMatchSale = async (data) => {
    return await instance.post('/api/report/match-sale', data);
};